'use strict';

module.exports = function () {
  return {
    $get: ['FirebaseUtil', 'AbstractDomainClass', '$$AbstractEvent',
      function (FirebaseUtil, AbstractDomainClass, $$AbstractEvent) {
        //console.log('Created  CalendarEventDomain');

        function CalendarEventDomain(data) {
          AbstractDomainClass.call(this, CalendarEventDomain, data);
        }

        $$AbstractEvent.__inheritFrom(CalendarEventDomain, 'CalendarEventDomain', 'calendar-events');

        CalendarEventDomain.$constraints.addConstraints({
          attendees: {type: 'DomainCollection', domainClass: 'PersonDomain'}
        });

        // more methods go here;

        return CalendarEventDomain;
      }]
  };
};


// WEBPACK FOOTER //
// ./src/js/calendar/domain/CalendarEventDomain.js